import React from "react";
import { BsPlusCircle } from "react-icons/bs";
import { IconContext } from "react-icons";

const CoursePackBox = ({ pack, onOpenModal }) => {
  const courses = pack.openQulRegs_pack || [];

  // מציאת התאריך ההתחלתי המוקדם ביותר
  const startDates = courses.map(c => new Date(c.mySelfQualificationDto?.startDate));
  const earliestStartDate = new Date(Math.min(...startDates));

  // חישוב עלות כוללת
  const totalPrice = courses.reduce((sum, course) => sum + (course.product?.price || 0), 0);

  const formatDate = (dateStr) =>
    new Date(dateStr).toLocaleDateString("he-IL", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

  return (
    // <div className="text-right flex flex-col border rounded-md m-2 p-2 bg-white shadow-sm" style={{ direction: "rtl" }}>
    <div className="text-right  flex flex-col border rounded-md m-2 p-1" style={{ direction: "rtl" }}>
      {/* <div className="text-base font-bold underline mb-2 text-green-800">פרטי מארז</div> */}
      <div className="text-base font-bold underline mb-1">פרטי מארז</div>

      {/* שמות ימי הכשירות */}
      <div className="mb-3">
        <span className="font-bold text-sm underline">ימי כשירות במארז:</span>
        <ul className="list-disc pr-5 mt-1 text-sm text-gray-700">
          {courses.map((course, idx) => (
            <li key={idx}>
              {course?.mySelfQualificationDto?.name || "ללא שם"}
            </li>
          ))}
        </ul>
      </div>

      {/* פרטים כלליים */}
      <div className="grid grid-cols-2 text-sm gap-4">
        <div className="flex items-center">
          <span className="ml-2 font-bold underline">תאריך התחלה:</span>
          <span>{formatDate(earliestStartDate)}</span>
        </div>

        <div className="flex items-center">
          <span className="ml-2 font-bold underline">עלות כוללת:</span>
          <span>{totalPrice.toLocaleString()} ₪</span>
        </div>
      </div>
  <IconContext.Provider value={{ size:"29px", className:"ml-2" }}>
            <button className='bg-[#1e8e2b] rounded-md text-white p-2 w-fit flex self-end items-center text-sm font-medium' onClick={onOpenModal}> <BsPlusCircle/> להרשמה ופרטים נוספים</button>
            </IconContext.Provider>
      {/* כפתור
      <IconContext.Provider value={{ size: "26px", className: "ml-2" }}>
        <button
          className="bg-[#1e8e2b] rounded-md text-white px-4 py-2 mt-4 w-fit flex self-end items-center text-sm font-medium"
          onClick={onOpenModal}
        >
          <BsPlusCircle /> להרשמה ופרטים נוספים
        </button>
      </IconContext.Provider> */}
    </div>
  );
};

export default CoursePackBox;